module.exports = __webpack_public_path__ + "img/dailyInspection_checked.7431be8e.png";